(function () {
  if (customElements.get('hesatek-ilp-content-tabs')) return;
  function classify(text) {
    const t=text.toLowerCase().replace(/\s+/g,' ').trim();
    if (/teknis|technical (?:data|spec)|specifications|tekniska|mallikood|mallinumer|paketin laitteet|lämmitysteho pakkasessa/.test(t)) return 'technical';
    if (/^(?:kenelle|millaisiin|mallin ilmoitettu käyttöala|suunniteltu suomalaisiin käyttökohteisiin|who.{0,12}(?:for|suit)|suitable for|vem passar)/.test(t)) return 'description';
    if (/^(?:materiaalit|esitteet|käyttöohjeet|dokumentit|documents|brochures|manuals|dokument|broschyrer|bruksanvisningar)/.test(t)) return 'documents';
    if (/^(?:asennus|helppo asennus|installation|installering)/.test(t)) return 'installation';
    if (/^(?:takuu|warranty|guarantee|garanti)/.test(t)) return 'warranty';
    return null;
  }
  function documentOnly(node) {
    if (node.nodeType!==1 || !/^(A|P|DIV|H[1-6]|LI)$/.test(node.tagName)) return false;
    const links=node.tagName==='A'?[node]:Array.from(node.querySelectorAll('a'));
    if (!links.length || node.querySelector('img,video,iframe,table,button')) return false;
    if (!links.every(a=>/\.pdf(?:[?#]|$)/i.test(a.getAttribute('href')||'') || /esite|käyttöohje|energiamerkin|takuuohje|brochure|manual|energy label|broschyr|bruksanvisning/.test(a.textContent.toLowerCase()))) return false;
    const copy=node.cloneNode(true);
    if (copy.tagName==='A') return true;
    copy.querySelectorAll('a').forEach(a=>a.remove());
    return copy.textContent.replace(/[\s.>,:;|→\-–]/g,'').length <= 1;
  }
  function partition(root) {
    let category='description',level=0;
    function visit(node) {
      if(node.nodeType!==1) return [[category,node.cloneNode(true)]];
      if(documentOnly(node)) return [['documents',node.cloneNode(true)]];
      if(/^H[1-6]$/.test(node.tagName)) {
        const depth=Number(node.tagName[1]),found=classify(node.textContent);
        if(found) { category=found;level=depth; }
        else if(depth<=level) { category='description';level=depth; }
        return [[category,node.cloneNode(true)]];
      }
      if(/^(DIV|SECTION|ARTICLE|MAIN)$/.test(node.tagName) || (/^(P|STRONG|SPAN|EM)$/.test(node.tagName) && Array.from(node.querySelectorAll('a')).some(a=>/^lataa|^download/i.test(a.textContent.trim())))) {
        const output=[];
        Array.from(node.childNodes).forEach(child=>visit(child).forEach(([key,part])=>{
          let last=output[output.length-1];
          if(!last || last[0]!==key) { const wrap=node.cloneNode(false); if(output.length) wrap.removeAttribute('id');last=[key,wrap];output.push(last); }
          last[1].appendChild(part);
        }));
        return output;
      }
      return [[category,node.cloneNode(true)]];
    }
    const groups={};
    Array.from(root.childNodes).forEach(node=>visit(node).forEach(([key,part])=>{
      if(!groups[key]) groups[key]=document.createDocumentFragment();
      groups[key].appendChild(part);
    }));
    return groups;
  }
  class ProductContentTabs extends HTMLElement {
    connectedCallback() {
      if(this.dataset.enhanced) return;
      const original=this.querySelector('[data-content-body="description"]');
      if(!original) return;
      const groups=partition(original);
      original.replaceChildren();
      Object.entries(groups).forEach(([key,fragment])=>{
        const target=this.querySelector('[data-content-body="'+key+'"]');
        if(target) target.appendChild(fragment);
      });
      this.querySelectorAll('[data-content-panel]').forEach(panel=>{
        const body=panel.querySelector('[data-content-body]');
        panel.hidden=!body.textContent.trim() && !body.querySelector('img,video,iframe,table,svg,button,a');
      });
      this.dataset.enhanced='true';
    }
  }
  customElements.define('hesatek-ilp-content-tabs',ProductContentTabs);
})();
